function parseTime(time, cFormat) {
    if (arguments.length === 0) {
      return null
    }
    const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
    let date
    if (typeof time === 'object') {
      date = time
    } else {
      if (('' + time).length === 10) time = parseInt(time) * 1000
      date = new Date(time)
    }
    const formatObj = {
      y: date.getFullYear(),
      m: date.getMonth() + 1,
      d: date.getDate(),
      h: date.getHours(),
      i: date.getMinutes(),
      s: date.getSeconds(),
      a: date.getDay()
    }
    const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
      let value = formatObj[key]
      // Note: getDay() returns 0 on Sunday
      if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value ] }
      if (result.length > 0 && value < 10) {
        value = '0' + value
      }
      return value || 0
    })
    return time_str
  }

    /**
     * 获取当前服务器时间毫秒数
     */
    function getServerNow() {
        const offset = Number(
            localStorage.getItem('ServerTimeOffset') || 0
        )

        return Date.now() + offset
    }


    /**
     * 获取当前服务器Date对象
     */
    function getServerDate() {
        return new Date(getServerNow())
    }


    /**
     * 获取格式化后的服务器时间
     * 用法：
     * getServerTime()
     * getServerTime('{y}-{m}-{d}')
     */
    function getServerTime(cFormat) {
        return parseTime(
            getServerNow(),
            cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
        )
    }

  export{
    parseTime,
      getServerNow,
      getServerDate,
      getServerTime
  }
